module.exports = __webpack_public_path__ + "img/avanzar-figura.42a947a9.svg";